(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FixationManagementController',FixationManagementController);

    FixationManagementController.$inject = ['$scope','$rootScope','FixationManagement','ToastrService','MiscService','DateUtils','SingleDblClickService','$uibModal','XLSXExportService','FixationManagementCustomService'];

    function FixationManagementController($scope, $rootScope, FixationManagement, ToastrService, MiscService, DateUtils, SingleDblClickService, $uibModal, XLSXExportService, FixationManagementCustomService) {
        var vm = this;

        vm.contractTypes = ['BOTH','PURCHASE','SALE'];
        vm.contracts = [];
        vm.pricingYears = [];
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'contractId';
        vm.reverse = true;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.refresh = refresh;
        vm.reset = reset;
        vm.openCalendar = openCalendar;
        vm.toggleNoPricing = toggleNoPricing;
        vm.toggleFixationOverPricing = toggleFixationOverPricing;
        vm.toggleFixationOverApplied = toggleFixationOverApplied;
        vm.toggleNeedsFixation = toggleNeedsFixation;
        vm.seeFixationUsage = seeFixationUsage;
        vm.downloadFixationReport = downloadFixationReport;

        vm.datePickerOpenStatus = {
            startDate: false,
            endDate: false
        };

        vm.toggleOptions = [false, true];

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function toggleNoPricing(value) {
            vm.filterModel.noPricing = value;
            if(value) {
                vm.filterModel.fixationOverApplied = false;
                vm.filterModel.fixationOverPricing = false;
                vm.filterModel.needsFixation = false;
                vm.filterModel.mar = false;
                vm.filterModel.may = false;
                vm.filterModel.jul = false;
                vm.filterModel.oct = false;
                vm.filterModel.dec = false;
            }
            loadAll();
        }

        function toggleFixationOverPricing(value) {
            vm.filterModel.fixationOverPricing = value;
            if(value) {
                vm.filterModel.noPricing = false;
            }
            loadAll();
        }

        function toggleFixationOverApplied(value) {
            vm.filterModel.fixationOverApplied = value;
            if(value) {
                vm.filterModel.noPricing = false;
            }
            loadAll();
        }

        function toggleNeedsFixation(value) {
            vm.filterModel.needsFixation = value;
            if(value) {
                vm.filterModel.noPricing = false;
            }
            loadAll();
        }

        vm.gridOptions = {
            paginationPageSizes: [10,25,50,75,100],
            paginationPageSize: 100,
            enableFiltering: false,
            enableGridMenu: true,
            enableRowSelection: true,
            enableSelectAll: false,
            showGridFooter: true,
            useExternalPagination: true,
            rowTemplate: SingleDblClickService.rowTemplate(),
            onRegisterApi: function(gridApi) {
                gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
                    vm.page = newPage - 1;
                    loadAll();
                });
                gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
                    if(sortColumns && sortColumns.length > 0 && sortColumns[0]) {
                        vm.predicate = sortColumns[0].field;
                        vm.reverse = sortColumns[0].sort.direction === 'asc';
                    } else {
                        vm.predicate = "contractId";
                        vm.reverse = true;
                    }
                    loadAll();
                });
                $scope.gridApi = gridApi;
            },
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Contract #', field: 'contractNum', width: 200, visible:true },
                { name: 'C.Date', field: 'contractDate', width: 110, visible:true },
                { name: 'C.Type', field: 'contractType', width: 100, visible:true },
                { name: 'C.Qty', field: 'contractQuantity', width: 100, visible:true },
                { name: 'C.Unit Type', field: 'contractQuantityUnitType', width: 120, visible:true },
                { name: 'P.Label', field: 'pricingLabel', width: 80, visible: true },
                { name: 'P.Month', field: 'pricingMonth', width: 100, visible:true },
                { name: 'P.Year', field: 'pricingYear', width: 80, visible:true },
                { name: 'P.Qty', field: 'pricingQty', width: 100, visible:true },
                { name: 'F.Total Qty', field: 'fixationQty', width: 110, visible:true },
                { name: 'F.Applied Qty', field: 'fixationAppliedQty', width: 130, visible:true },
                { name: 'F.Available Qty', field: 'fixationBalanceQty', width: 150, visible:true }
            ]
        };

        initFilter();
        loadAll();
        getPricingYears();

        function loadAll() {
            if(vm.gridOptions) {
                vm.gridOptions.data = [];
            }
            vm.contracts = [];
            var queryParams = {
                page: vm.page,
                size: vm.gridOptions.paginationPageSize,
                sort: sort()
            };
            queryParams = Object.assign({}, queryParams, vm.filterModel);
            FixationManagement.query(queryParams, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if(vm.predicate !== 'contractId') {
                    result.push('contractId');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.contracts = angular.copy(data);
                vm.gridOptions.data = vm.contracts;
                vm.gridOptions.totalItems = headers('X-Total-Count');
            }
            function onError(error) {
                ToastrService.error(error.data.message);
            }
        }

        function refresh() {
            loadAll();
        }

        function reset() {
            vm.contracts = [];
            vm.pricingYears = [];
            initFilter();
            loadAll();
            getPricingYears();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function initFilter() {
            vm.filterModel = {
                contractType: 'BOTH',
                startDate: "",
                endDate: "",
                contractNumber: "",
                year: "",
                draft: true,
                issued: true,
                complete: true,
                signed: true,
                cancelled: false,
                japan: true,
                tui: true,
                subCatJapan: true,
                subCatOutside: true,
                subCatPurchase: true,
                subCatDirect: true,
                mar: false,
                may: false,
                jul: false,
                oct: false,
                dec: false,
                noPricing: false,
                fixationOverPricing: false,
                fixationOverApplied: false,
                needsFixation: false
            }
        }

        function getPricingYears() {
            vm.pricingYears = [];
            FixationManagementCustomService.fetchUniquePricingYears().then(function(data) {
                angular.forEach(data.data, function(y) {
                    vm.pricingYears.push({val: y, name:y});
                });
                vm.pricingYears = data.data;
            }, function(error) {
                ToastrService.error("Failed to get Years", "Error!");
                console.log("error: " + JSON.stringify(error));
            });
        }

        vm.createTab = function(data) {
            $scope.$emit('handleEmit', data);
        };

        $scope.rowSingleClick = function(row) {
            if(row.entity.contractType === "PURCHASE") {
                SingleDblClickService.singleClickDTO(row, 'purchase.purchase-detail', 'fixation-management');
            } else {
                SingleDblClickService.singleClickDTO(row, 'sale.sale-detail', 'fixation-management');
            }
        };

        $scope.rowDblClick = function(row) {
            if(row.entity.contractType === "PURCHASE") {
                SingleDblClickService.dblClickDTO(row, 'purchase.edit', 'fixation-management');
            } else {
                SingleDblClickService.dblClickDTO(row, 'sale.edit', 'fixation-management');
            }
        };

        function seeFixationUsage() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/management/modal/fixation-usage.html',
                controller: 'FixationUsageModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return $scope.gridApi.selection.getSelectedRows()[0];
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(retVal) {
                if(retVal.action === "close") {
                    $scope.gridApi.selection.clearSelectedRows();
                    loadAll();
                } else {
                    $rootScope.$emit('handleEmit', retVal);
                }
            });
        }

        function downloadFixationReport() {
            var reportParams = Object.assign(vm.filterModel);
            XLSXExportService.downloadFixationReport(reportParams).then(function(data, status, headers, config) {
                var file = new Blob([data.data], {type:'application/vnd.ms-excel'});
                saveAs(file, "FixationReport.xls");
            }, function(error) {
                ToastrService.error("Failed to Download Report", "Error");
                console.log(JSON.stringify(error));
            });
        }

    }
})();
